/* eslint-disable no-nested-ternary */
/* eslint-disable react/forbid-prop-types */
import React from 'react';
import { connect } from 'react-redux';
import { makeStyles } from '@material-ui/core/styles';
import PropTypes from 'prop-types';
import { Button, Grid } from '@material-ui/core';
import placementTestActions from '../../../redux/actions/placementTestActions';

const useStyles = makeStyles((theme) => ({
  button: {
    marginTop: theme.spacing(4),
  },
  buttonRoot: {
    padding: '0 2em',
  },
}));

const MCQAnswers = ({
  answers, currentAnswer, setCurrentAnswer, questionId, multiQuestionId,
}) => {
  const classes = useStyles();

  return (
    <Grid container direction="row">
      {
        answers.map((answer, index) => (
          <Grid
            item
            xs={12}
            sm={6}
            className={classes.buttonRoot}
            key={answer.text}
          >
            <Button
              className={classes.button}
              variant={currentAnswer.length > 0 ? (currentAnswer[multiQuestionId].answerIndex[0] === index ? 'contained' : 'outlined') : 'outlined'}
              color="primary"
              onClick={() => setCurrentAnswer([{ question: questionId, answerIndex: [index] }])}
              fullWidth
            >
              {answer.text}
            </Button>
          </Grid>
        ))
      }
    </Grid>
  );
};

MCQAnswers.propTypes = {
  answers: PropTypes.array.isRequired,
  currentAnswer: PropTypes.array.isRequired,
  questionId: PropTypes.string.isRequired,
  setCurrentAnswer: PropTypes.func.isRequired,
  multiQuestionId: PropTypes.number.isRequired,
};

const actionCreators = {
  setCurrentAnswer: placementTestActions.setCurrentAnswer,
};

export default connect(null, actionCreators)(MCQAnswers);
